import { axios } from '@/plugins/axios';
import {
	ISearchPsychologist,
	SearchPsychologist
} from '@/types/models/SearchPsychologist';

/**
 * Service pour les appels API liés aux posts
 */
export class PsychologistApiService {
	/**
	 * Récupère les psychologues avec certains filtres
	 * @param coordinates_x Coordonnée en longitude
	 * @param coordinates_y Coordonnée en latitude
	 * @param children Accepte les enfants
	 * @param teleconsultation Accepte les séances à distance
	 * @returns Des psychologues
	 */
	public static getPsychologistListByCoordinatesAndChildrenAndTeleconsultation(
		coordinates_x: number, coordinates_y: number, children: boolean, teleconsultation: boolean): Promise<SearchPsychologist[]> {

		const psychologistsSearchParams = {
			coordinates_x,
			coordinates_y,
			...{ children: children ? children : null },
			...{ teleconsultation: teleconsultation ? teleconsultation : null }
		};

		return axios.get<ISearchPsychologist[]>('psychologists/search', {
			params: {
				...psychologistsSearchParams
			}
		})
			.then(psychologistListResponse => psychologistListResponse.data.map(p => new SearchPsychologist(p)))
			.catch(() => []);
	}
}
